module.exports = __webpack_public_path__ + "static/media/check_immo.a9e5de80.png";